import { LinearProgress } from '@mui/material'
import { RichListCardLayout } from './RichListCardLayout'

export function RichListCardSkeleton() {
  return <RichListCardLayout content={<LinearProgress />}></RichListCardLayout>
}
